import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {Switch} from "@/components/ui/switch.tsx";

const LocaleToggle = () => {
    const { i18n } = useTranslation();
    const [isFrench, setIsFrench] = useState(localStorage.getItem('locale') === 'fr');

    useEffect(() => {
        const currentLocale = localStorage.getItem('locale') || 'en';
        i18n.changeLanguage(currentLocale);
        setIsFrench(currentLocale === 'fr');
    }, [i18n]);

    const handleLocaleChange = () => {
        const newLocale = isFrench ? 'en' : 'fr';
        setIsFrench(!isFrench);
        i18n.changeLanguage(newLocale);
        localStorage.setItem('locale', newLocale);
    };

    return (
        <div className="flex items-center space-x-2">
            <span>EN</span>
            <Switch checked={isFrench} onCheckedChange={handleLocaleChange} />
            <span>FR</span>
        </div>
    );
};

export default LocaleToggle;
